import { Injectable, inject } from '@angular/core';
import { DBService } from './db-service';
import { Observable } from 'rxjs';
import { InspectionElementDto } from '../api/model/models';

@Injectable()
export class InspectionCategoryDBService {
  private dbService = inject(DBService);

  private readonly idPrefixInspectionCategory = 'inspection_category_';

  public getInspectionCategory(inspectionCategoryNumber: string): Observable<InspectionElementDto> {
    const id = this.getInspectionCategoryId(inspectionCategoryNumber);
    return this.dbService.getById<InspectionElementDto>(id);
  }

  public getAllInspectionCategories(): Observable<InspectionElementDto[]> {
    return this.dbService.getAll(this.idPrefixInspectionCategory);
  }

  public putInspectionCategory(inspectionCategory: InspectionElementDto): Observable<string> {
    const id = this.getInspectionCategoryId(inspectionCategory.number);
    return this.dbService.put<InspectionElementDto>(inspectionCategory, id);
  }

  private getInspectionCategoryId(inspectionCategoryNumber: string | null | undefined): string {
    return `${this.idPrefixInspectionCategory}${inspectionCategoryNumber ?? ''}`;
  }
}
